import { useCallback } from 'react'
import { centsClient } from '../../api/cents/clients/cents-client'

interface IntentHook {
  intent: (charityId: string, contractId: string, isActivation?: boolean) => Promise<string>
}

export function useIntent(): IntentHook {
  const intent = useCallback(async (charityId: string, contractId: string, isActivation?: boolean) => {
    return await centsClient.contracts.intent(charityId, contractId, isActivation)
  }, [])

  return { intent }
}
